module Meevo.Plugins.Client {
    "use strict";
    /**
    * VisitNotesSection Section -- need aggregate model for handling.
    */



    export class VisitNotesSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.Client> {
        public canReadPrivateVisitNoteAccess: boolean = false;
        public canAddPrivateVisitNoteAccess: boolean = false;
        public canEditPrivateVisitNoteAccess: boolean = false;
        public canDeletePrivateVisitNoteAccess: boolean = false;
        public canApproveVisitNoteAccess: boolean = false;
        public showDeletePrivateVisitNoteButton: boolean = false;
        public showEditPrivateVisitNoteButton: boolean = false;

        public sortOptions: any[] = [
            { sortBy: "DateCreated", sortDirection: 1, label: "LABEL_CREATED_NEWEST" },
            { sortBy: "DateCreated", sortDirection: 0, label: "LABEL_CREATED_OLDEST" },
            { sortBy: "DateUpdated", sortDirection: 1, label: "LABEL_UPDATED_NEWEST" },
            { sortBy: "DateUpdated", sortDirection: 0, label: "LABEL_UPDATED_OLDEST" }
        ];

        public selectedVisitNoteSortOption: any = this.sortOptions[0];

        public isAnnotationRequired: boolean = false;
        public isAnnotationNewFileRequired: boolean = false;
        public isImageDefined: boolean = false;

        public windowInnerWidth = window.innerWidth;
        public windowInnerHeight = window.innerHeight;

        public imageWidth = this.windowInnerWidth > 500 ? 500 : 300;
        public imageHeight = this.windowInnerHeight > 500 ? 500 : 300;

        private itemBackup: any;
        private itemVisitNoteTypeChanged: boolean = false;
        private previousVisitNoteType: any;
        private previousVisitNoteText: string = "";

        public minCalendarDate = moment().add('year', -5).startOf('year').toDate();
        public maxCalendarDate = moment().toDate();

        public timeVisited = moment().toDate();
        public isVisitedToday = true;

        protected MAX_TEXT_LENGTH: number = 20000;

        constructor(
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.BaseClasses.IDataService,
            protected identityService: Meevo.Components.Common.IIdentityService = null,
            protected securityService: Meevo.Components.Common.ISecurityService,
            noun: Meevo.Model.NounEnum = null,
            protected $scope: angular.IScope,
            protected $q: angular.IQService,
            public $sce: ng.ISCEService,
            private $translate: ng.translate.ITranslateService,
            appSettings?: Components.Common.IAppSettings,
            sectionSecurityKey?: string,
            protected modalService?: Meevo.Components.Modal.IModalService
        ) {
            super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint,
                loggingService, dataService, identityService, noun, appSettings, sectionSecurityKey);

            var privateVisitNoteKeys: string[] = [
                Meevo.Components.Common.SecurityKeys.DATA_CLIENT_TAB_VISITNOTES_PRIVATE + Meevo.Components.Common.SecurityParts.KEY_PART_READ,
                Meevo.Components.Common.SecurityKeys.DATA_CLIENT_TAB_VISITNOTES_PRIVATE + Meevo.Components.Common.SecurityParts.KEY_PART_CREATE,
                Meevo.Components.Common.SecurityKeys.DATA_CLIENT_TAB_VISITNOTES_PRIVATE + Meevo.Components.Common.SecurityParts.KEY_PART_WRITE,
                Meevo.Components.Common.SecurityKeys.DATA_CLIENT_TAB_VISITNOTES_PRIVATE + Meevo.Components.Common.SecurityParts.KEY_PART_DELETE,
            ];
            securityService
                .checkAndCache(privateVisitNoteKeys)
                .then((accessValues: Model.SecurityItem[]) => {
                    let readAccess = _.findWhere(accessValues, { key: Meevo.Components.Common.SecurityKeys.DATA_CLIENT_TAB_VISITNOTES_PRIVATE + Meevo.Components.Common.SecurityParts.KEY_PART_READ });
                    if (readAccess) {
                        this.canReadPrivateVisitNoteAccess = (readAccess.securityAccess != Model.SecurityAccessEnum.Hide);
                    }
                    let addAccess = _.findWhere(accessValues, { key: Meevo.Components.Common.SecurityKeys.DATA_CLIENT_TAB_VISITNOTES_PRIVATE + Meevo.Components.Common.SecurityParts.KEY_PART_CREATE });
                    if (addAccess) {
                        this.canAddPrivateVisitNoteAccess = (addAccess.securityAccess == Model.SecurityAccessEnum.Grant);
                    }
                    let editAccess = _.findWhere(accessValues, { key: Meevo.Components.Common.SecurityKeys.DATA_CLIENT_TAB_VISITNOTES_PRIVATE + Meevo.Components.Common.SecurityParts.KEY_PART_WRITE });
                    if (editAccess) {
                        this.canEditPrivateVisitNoteAccess = (editAccess.securityAccess == Model.SecurityAccessEnum.Grant);
                        this.showEditPrivateVisitNoteButton = (editAccess.securityAccess !== Model.SecurityAccessEnum.Hide);
                    }
                    let deleteAccess = _.findWhere(accessValues, { key: Meevo.Components.Common.SecurityKeys.DATA_CLIENT_TAB_VISITNOTES_PRIVATE + Meevo.Components.Common.SecurityParts.KEY_PART_DELETE });
                    if (deleteAccess) {
                        this.canDeletePrivateVisitNoteAccess = (deleteAccess.securityAccess == Model.SecurityAccessEnum.Grant);
                        this.showDeletePrivateVisitNoteButton = (deleteAccess.securityAccess !== Model.SecurityAccessEnum.Hide);
                    }
                    let approveAccess = _.findWhere(accessValues, { key: Meevo.Components.Common.SecurityKeys.DATA_CLIENT_TAB_VISITNOTES_APPROVE});
                    if (approveAccess) {
                        this.canApproveVisitNoteAccess = (approveAccess.securityAccess == Model.SecurityAccessEnum.Grant);
                    }
                });
        }

        public VisitNoteTextChanged(noteText, visitNoteType) {
            if (noteText && visitNoteType) {
                this.previousVisitNoteText = noteText;
            }
            this.isAnnotationNewFileRequired = (!this.isImageDefined && (!noteText || noteText.length == 0));
        }

        public isItemOwned(item: any): boolean {
            return Model.Guard.isSomething(item) && item.locationId === this.identityService.current().locationId;
        }

        public unownedItemNotification(): void {
            this.modalService.alert("HEADER_VISIT_NOTES_LOCATION_MODIFICATION_VIOLATION");
        }

        public onEditAction(item: any, canPerformAction: { (): boolean }, canEditModelEvenWhenRestricted: boolean, actionOnItem: { (item: any): void }) {
            this.itemBackup = angular.copy(item);
            this.previousVisitNoteType = null;
            this.itemVisitNoteTypeChanged = false;
            this.getVisitNoteTypeDetail(item, true)
                .then(() => {
                    this.onPerformAction(item, canPerformAction, canEditModelEvenWhenRestricted, actionOnItem);
                });
        }

        public onPerformAction(item: any, canPerformAction: { (): boolean }, canEditModelEvenWhenRestricted: boolean, actionOnItem: { (item: any): void }) {
            if (canEditModelEvenWhenRestricted) {
                if (canPerformAction() && this.isItemOwned(item)) {
                    actionOnItem(item);
                }
                else {
                    this.unownedItemNotification();
                }
            }
            else {
                this.modalService.alert("MESSAGE_CANNOT_EDIT_RESTRICTED_CLIENT");
            }
        }

        public onDeleteAction(item: any, canPerformAction: { (): boolean }, canEditModelEvenWhenRestricted: boolean, actionOnItem: { (item: any, confirmationMessage?): void }) {
            if (canEditModelEvenWhenRestricted) {
                if (canPerformAction() && this.isItemOwned(item)) {
                    item && item.isReviewed ? actionOnItem(item, "MESSAGE_DELETE_REVIEWED_VISIT_NOTE_CONFIRMATION") : actionOnItem(item)
                }
                else {
                    this.unownedItemNotification();
                }
            }
            else {
                this.modalService.alert("MESSAGE_CANNOT_EDIT_RESTRICTED_CLIENT");
            }
        }
        public showNoPermissionAlert() {
            this.modalService.alert("MESSAGE_NO_PRIVATE_VISIT_NOTE_PERMISSIONS");
        }

        getVisitNoteTypeDetail(item, isEditingAndOnInit: boolean = false): ng.IPromise<any> {
            if (item) {
                if (!isEditingAndOnInit || (this.itemBackup && item.visitNoteType && this.itemBackup.visitNoteType.id != item.visitNoteType.id)) {
                    this.resetAnnotation(item);
                }

                if (this.previousVisitNoteType && item.visitNoteType && this.previousVisitNoteType.id != item.visitNoteType.id) {
                    
                    this.getClientVisitNoteType(item.visitNoteType.id).then((data) => {
                        var newNoteTypeData = data.data;
                        item.requiresReview = newNoteTypeData.requiresReview
                        // When the previously selected Note Type and the currently selected note type do not have templates then do not change the note text and do not show a modal
                        if (!newNoteTypeData.hasTemplate && this.previousVisitNoteType && !this.previousVisitNoteType.hasTemplate) {
                            item.isFormatted = false;
                            this.previousVisitNoteType = newNoteTypeData;
                            this.previousVisitNoteText = item.noteText;
                        }
                        // When the newly selected note type does not have a template then ask if user is okay with losing the text they wrote
                        else if (!newNoteTypeData.hasTemplate) {
                            var message = this.$translate.instant("MESSAGE_VISIT_NOTE_DOES_NOT_HAVE_TEMPLATE_CHANGE_WARNING", { visitNoteTypeDisplayName: newNoteTypeData.displayName });

                            this.modalService.yellowConfirm(message, 0, true).then(() => {
                                this.previousVisitNoteType = newNoteTypeData;
                                item.noteText = "";
                                item.isFormatted = false;
                                this.previousVisitNoteText = item.noteText;
                            }).catch(() => {
                                item.noteText = this.previousVisitNoteText;
                                item.isFormatted = this.previousVisitNoteType.hasTemplate;
                                item.visitNoteType = this.previousVisitNoteType;
                            });
                        }
                        // Anytime a newly selected note type has a template then ask if user is okay with losing the text they wrote
                        else {
                            var message = this.$translate.instant("MESSAGE_VISIT_NOTE_HAS_TEMPLATE_CHANGE_WARNING", { visitNoteTypeDisplayName: item.visitNoteType.displayName });

                            this.modalService.yellowConfirm(message, 0, true).then(() => {
                                this.previousVisitNoteType = newNoteTypeData;
                                item.noteText = newNoteTypeData.templateText;
                                item.isFormatted = newNoteTypeData.hasTemplate;
                                this.previousVisitNoteText = item.noteText;
                            }).catch(() => {
                                item.noteText = this.previousVisitNoteText;
                                item.isFormatted = this.previousVisitNoteType.hasTemplate;
                                item.visitNoteType = this.previousVisitNoteType;
                            });
                        }
                    });
                }
                else if (item.visitNoteType && item.visitNoteType.id) {
                    this.GetVisitNoteTypeTemplate(item);
                }

                // Get clientVisitNote's original image && annotation data
                if (isEditingAndOnInit && (this.itemBackup && this.itemBackup.visitNoteType && item.visitNoteType && this.itemBackup.visitNoteType.id == item.visitNoteType.id)) {
                    if (Meevo.Model.Guard.isSomething(item.annotationFileGuidOriginal)) {
                        return this.getClientVisitNoteImageData(item.id, item.annotationFileGuidOriginal, item.annotationFileGuid, item.contentType).then((response: any) => {
                            if (response && response.data) {
                                if (response.data.annotationBackgroundDataObj) {
                                    item.annotationBackgroundData = response.data.annotationBackgroundDataObj.data;
                                }
                                if (response.data.annotationDataObj) {
                                    item.annotationData = response.data.annotationDataObj.data;
                                }
                                if (item.visitNoteType.id == this.itemBackup.visitNoteType.id && !item.annotationBackgroundData) {
                                    this.itemBackup.annotationBackgroundData = item.annotationBackgroundData;
                                    this.itemBackup.annotationData = item.annotationData;
                                }
                            }
                        });
                    }
                }
                else {
                    if (item.annotationFileGuid) {
                        item.isAnnotationReplacedOrRemoved = true;
                    }

                    // Get visitNoteType's annotation image.
                    if (item.visitNoteType) {
                        item.isAnnotationEnabled = item.visitNoteType.isAnnotationEnabled;

                        if (item.visitNoteType.fileGuid) {
                            var promise = this.getVisitNoteTypeImageData(item.visitNoteType.id, item.visitNoteType.fileGuid, item.contentType);
                            this.isImageDefined = true;
                            return promise.then(img => {
                                if (img.data) {
                                    item.annotationBackgroundData = img.data.data;
                                }
                            });
                        }
                    }
                    else {
                        item.isAnnotationEnabled = false;
                    }
                }

            }

            return this.$q.resolve();
        }

        // Get Visit Note Type Template
        GetVisitNoteTypeTemplate(item): any
        {
            this.getClientVisitNoteType(item.visitNoteType.id).then(data => {
                if (data && data.data && data.data.hasTemplate) {
                    // Editing an existing Client Visit Note
                    if (this.previousVisitNoteType && this.previousVisitNoteType.id != item.visitNoteType.id) {
                        item.noteText = data.data.templateText;
                        item.isFormatted = data.data.hasTemplate;
                    }
                    // When adding a new Client Visit Note
                    else if (this.previousVisitNoteType == null && Model.Guard.isNothing(item.noteText)) {
                        item.noteText = data.data.templateText;
                        item.isFormatted = data.data.hasTemplate;
                    }
                }
                item.requiresReview = data.data.requiresReview
                this.previousVisitNoteType = data.data;
            });
        }


        getVisitNoteTypeImageData(id, fileGuid, mimeType): ng.IPromise<any> {
            if (id && fileGuid) {
                return this.dataService.customMethodData(`api/VisitNoteType/${id}/Image`, "POST",
                    {
                        "FileGuid": fileGuid,
                        "MimeType": mimeType
                    });
            }
            else {
                return this.$q.resolve({ data: null });
            }
        }

        getClientVisitNoteImageData(id, origFileGuid, annotatedFileGuid, mimeType): ng.IPromise<any> {
            if (id && origFileGuid) {
                return this.dataService.customMethodData(`api/Client/${this.parentItemId}/VisitNotes/${id}/Image`, "POST",
                    {
                        "FileGuid": origFileGuid,
                        "AnnotatedFileGuid": annotatedFileGuid,
                        "MimeType": mimeType
                    });
            }
            else {
                return this.$q.resolve({ data: { annotationDataObj: null, annotationBackgroundDataObj: null } });
            }
        }

        getClientVisitNoteType(id): ng.IPromise<any> {
            return this.dataService.customMethodData(`api/VisitNoteType/${id}`, "GET", null);
        }

        validateAnnotation(item, vm: any): any {
            this.isAnnotationRequired = false;
            this.isAnnotationNewFileRequired = false;

            if (item && (item.isAnnotationEnabled || (item.visitNoteType && item.visitNoteType.isAnnotationEnabled))) {
                if (!item.noteText) {
                    // Annotation image is required when either no image is associated with visitNoteType or
                    // User replaced/removed the existing image associated with clientVisitNote.
                    if (!item.annotationBackgroundData) {
                        this.isAnnotationNewFileRequired = true;
                        this.modalService.alert("LABEL_CLIENTVISITNOTES_ANNOTATION_IMAGEREQUIRED", 0, true);
                        return;
                    }

                    // Annotation is always required except when new annotation image is uploaded
                    if (!item.isAnnotated && !item.annotationFileGuidNew) {
                        this.isAnnotationRequired = true;
                        this.modalService.alert("LABEL_CLIENTVISITNOTES_ANNOTATION_REQUIRED", 0, true);
                        return;
                    }

                    // NoteText is a "NOT NULL" field. On the contrary, its also NOT required when annotation is enabled.
                    // Therefore, saving the noteText with a space when user ignores it but chooses annotation.
                    if (this.isImageDefined) {
                        this.modalService.alert("LABEL_CLIENTVISITNOTES_ANNOTATION_NOTETEXTREQUIRED", 0, true);
                    } else {
                        this.modalService.alert("LABEL_CLIENTVISITNOTES_ANNOTATION_IMAGEREQUIRED", 0, true);
                    }
                }
            }

            if (item && item.noteText && item.noteText.length > this.MAX_TEXT_LENGTH) {
                let msg = this.$translate.instant("MESSAGE_VISIT_NOTE_TEXT_OVER_LIMIT", { visitNoteTextLimit: "20k" });
                return this.modalService.alert(msg);
            }

            vm.save();
            this.itemBackup = null;
            this.itemVisitNoteTypeChanged = false;
        }

        editAnnotation(item): any {
            if (item) {
                this.modalService.yellowConfirm('MESSAGE_CLIENTVISITNOTES_ANNOTATION_UPDATE_CONFIRMATION', 0, true, null, false).then((confirmResult: boolean) => {
                    if (confirmResult) {
                        this.resetAnnotation(item);
                        item.isAnnotationReplacedOrRemoved = true;

                        // Pop-up modal to upload new image. 
                        document.getElementById('imageUploadBtn').click();
                    }
                });
            }
        }

        deleteAnnotation(item): any {
            if (item) {
                this.modalService.yellowConfirm('MESSAGE_CLIENTVISITNOTES_ANNOTATION_DELETE_CONFIRMATION', 0, true, null, false).then((confirmResult: boolean) => {
                    if (confirmResult) {
                        this.resetAnnotation(item);
                        item.isAnnotationReplacedOrRemoved = true;
                    }
                });
            }
        }

        clearAnnotation(item): any {
            item.isAnnotationReplacedOrRemoved = true;
        }

        resetAnnotation(item): void {
            item.annotationBackgroundData = '';
            item.annotationData = '';
            item.isAnnotated = false;

            if (item.annotationFileGuidNew) {
                item.annotationFileGuidNew = '';
                item.annotationFileNew = '';
            }
        }

        trustHtml = function (string) {
            return this.$sce.trustAsHtml(string);
        }

        dateVisitedChanged(item): void {
            if (item) {
                if (moment(item.dateVisited).format('YYYY-MM-DD') != moment(this.maxCalendarDate).format('YYYY-MM-DD')) {
                    this.isVisitedToday = false;
                }
                else {
                    this.isVisitedToday = true;
                }
                this.setTimeVisited(item);
            }
        }

        setTimeVisited(item): void {
            if (item) {
                if (!this.isVisitedToday) {
                    var date = moment(item.dateVisited);
                    var time = moment(this.timeVisited);
                    date.hour(time.hour());
                    date.minute(time.minute());
                    date.second(time.second());
                    item.dateVisited = date.format();
                }
                else {
                    item.dateVisited = moment().format();
                    this.timeVisited = moment().toDate();
                }
            }
        }

        getLabelForReviewApproveCheckbox(item) {
            if (item.isReviewed) {
                let approverName: string;
                if (item.lastReviewedByNickName) {
                    if (item.lastReviewedByFirstName && item.lastReviewedByLastName) {
                        approverName = item.lastReviewedByNickName + ": " + item.lastReviewedByFirstName + " " + item.lastReviewedByLastName;
                    }
                    else {
                        approverName = item.lastReviewedByNickName;
                    }
                }
                else {
                    approverName = this.identityService.current().userName;
                }
                return this.$translate.instant('LABEL_VISIT_NOTE_TYPE_REVIEWED_BY', { approverName: approverName });
            }
            return "LABEL_VISIT_NOTE_TYPE_APPROVE_REVIEWED";
        }

        public getLastReviewedByDisplayName(item) {
            if (item && item.isReviewed) {
                if (item.lastReviewedByNickName) {
                    if (item.lastReviewedByFirstName && item.lastReviewedByLastName) {
                        return item.lastReviewedByNickName + ": " + item.lastReviewedByFirstName + " " + item.lastReviewedByLastName;
                    }
                    else {
                        return item.lastReviewedByNickName;
                    }
                }
                else {
                    return this.identityService.current().userName;
                }
            }
            return "";
        }
    }
}